export const notificationAuthStatus = [
  { key: "M", badgeColor: "success" },
  { key: "A", badgeColor: "warning" },
];

export const notificationIsReadFilter = [
  { label: "Chưa đọc", value: "M" },
  { label: "Đã đọc", value: "A" },
];

export const notificationModeList = {
  VIEW_NOTIFICATION_DETAIL: "VIEW_NOTIFICATION_DETAIL",
};

export const notificationType = {
  ORDER: 1,
};

const TICKET_NOTIFICATION_TYPES = [
  "TICKET_CREATED",
  "TICKET_SEND_TO_SALE",
  "TICKET_PROCESSED",
  "TICKET_SKIPPED",
  "TICKET_COMPLETED",
];

export const getInitNotificationParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
  };
};

export function notificationLink(notification) {
  const item = notification?.notification || {};

  if (item.order_id) {
    return `/manage-orders/${item.order_id}`;
  }

  const notificationTypeKey = String(item.notification_type || "")
    .trim()
    .toUpperCase();

  if (TICKET_NOTIFICATION_TYPES.includes(notificationTypeKey)) {
    const isMyTicketsPath =
      typeof window !== "undefined" &&
      window.location.pathname.includes("/my-tickets");

    return isMyTicketsPath ? "/my-tickets" : "/ticket-management";
  }

  return `/manage-orders/${item.order_id}`;
}
